// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { identity } from 'lodash';
import { connect } from 'react-redux';

// Decorators
import sketchResizeDecorator from './sketchResizeDecorator';
import elementLineEdgeDropTarget from '../../line/elementLineEdgeDropTarget';
import dontUpdateForKeys from '../../../utils/milanoteRecompose/dontUpdateForKeys';
import captionContainerDecorator from '../../../components/caption/captionContainerDecorator';

// Actions
import { deselectAllElements } from '../../selection/selectionActions';
import { navigateToElement } from '../../../reducers/navigationActions';

// Utils
import { getDrawingSvg } from '../../../../common/elements/utils/elementPropertyUtils';

// Components
import Sketch from './Sketch';
import groupResizeStateDecorator from '../../resizing/groupResizeStateDecorator';
import groupResizeBehaviourDecorator from '../../resizing/groupResizeBehaviourDecorator';

// Constants
import { MaintainAspectRatioMode } from '../../resizing/resizeTypes';
import { SKETCH_MIN_HEIGHT, SKETCH_MIN_WIDTH } from '../../../../common/drawings/sketches/sketchConstants';
import elementSaveMediaResizeDecorator from '../../resizing/mediaResize/elementSaveMediaResizeDecorator';

const mapDispatchToProps = (dispatch) => ({
    dispatchDeselectAndNavigateToElement: (elementId) => {
        dispatch(deselectAllElements({ sync: false }));
        dispatch(navigateToElement({ elementId }));
    },
});

const getShouldMaintainAspectRatio = ({ element }) =>
    getDrawingSvg(element) ? MaintainAspectRatioMode.OPTIONAL : MaintainAspectRatioMode.NEVER;

@elementLineEdgeDropTarget
@dontUpdateForKeys(['dragModifierKeys', 'canDrop'])
@captionContainerDecorator
@groupResizeStateDecorator(getShouldMaintainAspectRatio, SKETCH_MIN_WIDTH, SKETCH_MIN_HEIGHT)
@elementSaveMediaResizeDecorator()
@sketchResizeDecorator
@groupResizeBehaviourDecorator()
@connect(null, mapDispatchToProps)
class SketchContainer extends React.Component {
    handleKey = (event) => {
        const { isSelected, captionKeyHandler, isEditing } = this.props;

        if (!isSelected) return;
        if (isEditing) return; // let tiptap handle keypresses if active

        captionKeyHandler(event, this.props);
    };

    render() {
        const { connectLineEdgeDropTarget, canConnectLineEdge } = this.props;

        const lineEdgeConnector =
            connectLineEdgeDropTarget && canConnectLineEdge ? connectLineEdgeDropTarget : identity;

        return lineEdgeConnector(
            <div className="SketchContainer" onKeyDown={this.handleKey} tabIndex="-1">
                <Sketch {...this.props} />
            </div>,
        );
    }
}

SketchContainer.propTypes = {
    element: PropTypes.object.isRequired,

    canConnectLineEdge: PropTypes.bool,
    isSelected: PropTypes.bool,
    isEditing: PropTypes.bool,

    connectLineEdgeDropTarget: PropTypes.func,
    captionKeyHandler: PropTypes.func,
};

export default SketchContainer;
